/**
 * 相框路由
 * */
export default [
  {
    path: '/photoIndexNew',
    name: 'photoIndexNew',
    component: () => import('@/views/PhotoSystem/index'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/photoIndex',
    name: 'photoIndex',
    component: () => import('@/views/PhotoSystem/indexNew'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/photoChannelList',
    name: 'photoChannelList',
    component: () => import('@/views/PhotoSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },
  {
    path: '/photoMachineList',
    name: 'photoMachineList',
    component: () => import('@/views/PhotoSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },
  {
    path: '/photoDeviceList',
    name: 'photoDeviceList',
    component: () => import('@/views/PhotoSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },
  {
    path: '/photoUserList',
    name: 'photoUserList',
    component: () => import('@/views/PhotoSystem/baby/photoUserList'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/photoOtaManger',
    name: 'photoOtaManger',
    component: () => import('@/views/PhotoSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },
  {
    path: '/photoAppManager',
    name: 'photoAppManager',
    component: () => import('@/views/PhotoSystem/apply/appManager'),
    meta: {
      title: 'APP管理'
    }
  },
  {
    path: '/photoOtaDownloadLogs',
    name: 'photoOtaDownloadLogs',
    component: () => import('@/views/PhotoSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },
  {
    path: '/photoAppExclude',
    name: 'photoAppExclude',
    component: () => import('@/views/PhotoSystem/apply/photoAppExclude'),
    meta: {
      title: 'APP黑名单'
    }
  },
  {
    path: '/photoDeviceInstruction',
    name: 'photoDeviceInstruction',
    component: () => import('@/views/PhotoSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },
  {
    path: '/photoContactsList',
    name: 'photoContactsList',
    component: () => import('@/views/PhotoSystem/deviceManage/photoContactsList'),
    meta: {
      title: '设备绑定'
    }
  },
  {
    path: '/photoImeiErrorLogList',
    name: 'photoImeiErrorLogList',
    component: () => import('@/views/PhotoSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },
  {
    path: '/photoUpload',
    name: 'photoUpload',
    component: () => import('@/views/PhotoSystem/bi/photoUpload'),
    meta: {
      title: '上传情况'
    }
  },
  {
    path: '/photoP2PLogView',
    name: 'photoP2PLogView',
    component: () => import('@/views/PhotoSystem/baby/p2pLogView'),
    meta: {
      title: 'P2P日志'
    }
  },
 {
    path: '/photoAddModelPage',
    name: 'photoAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/addModelPage')
  },{
    path: '/photoEditModelPage',
    name: 'photoEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/editModelPage')
  },{
    path: '/photoDeviceMonthRegister',
    name: 'photoDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/PhotoSystem/bi/deviceMonthRegister')
  },{
    path: '/photoUserMonthRegister',
    name: 'photoUserMonthRegister',
    meta: {
      title: '用户统计'
    },
    component: () => import('@/views/PhotoSystem/bi/userMonthRegister')
  },{
    path: '/photoOtaUpdateAddPage',
    name: 'photoOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/PhotoSystem/apply/otaUpdateAddPage')
  },{
    path: '/photoOtaUpdateEditPage',
    name: 'photoOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/PhotoSystem/apply/otaUpdateEditPage')
  },{
    path: '/photoAppUpdateAddPage',
    name: 'photoAppUpdateAddPage',
    meta: {
      title: 'APP新增'
    },
    component: () => import('@/views/PhotoSystem/apply/appUpdateAddPage')
  },{
    path: '/photoAppUpdateEditPage',
    name: 'photoAppUpdateEditPage',
    meta: {
      title: 'APP编辑'
    },
    component: () => import('@/views/PhotoSystem/apply/appUpdateEditPage')
  },{
    path: '/photoApkUpdateAddPage',
    name: 'photoApkUpdateAddPage',
    meta: {
      title: 'APK新增'
    },
    component: () => import('@/views/PhotoSystem/apply/apkUpdateAddPage')
  },{
    path: '/photoApkUpdateEditPage',
    name: 'photoApkUpdateEditPage',
    meta: {
      title: 'APK编辑'
    },
    component: () => import('@/views/PhotoSystem/apply/apkUpdateEditPage')
  },{
    path: '/photoApkManager',
    name: 'photoApkManager',
    meta: {
      title:'APK管理'
    },
    component: () => import('@/views/PhotoSystem/apply/apkManager')
  },{
    path: '/photoDeviceQualityAssessment',
    name: 'photoDeviceQualityAssessment',
    meta: {
      title:'智能测试'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/photoDeviceAuthList',
    name: 'photoDeviceAuthList',
    meta: {
      title:'设备授权'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/deviceAuthList'),
  },{
    path: '/photoActivateList',
    name: 'photoActivateList',
    meta: {
      title:'设备激活管理'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/activateList'),
  },{
    path: '/photoChannelAppPage',
    name: 'photoChannelAppPage',
    component: () => import('@/views/PhotoSystem/deviceManage/ChannelAppPage'),
    meta: {
      title:'渠道APP管理'
    }
  },{
    path: '/videoCallDay',
    name: 'videoCallDay',
    meta: {
      title:'视频通话统计'
    },
    component: () => import('@/views/PhotoSystem/bi/videoCallDay'),
  },{
    path: '/photoCheckModel',
    name: 'photoCheckModel',
    component: () => import('@/views/PhotoSystem/deviceManage/checkModel'),
    meta: {
      title:'查看机型'
    }
  },{
    path: '/photoCheckChannelPage',
    name: 'photoCheckChannelPage',
    component: () => import('@/views/PhotoSystem/deviceManage/checkChannelPage'),
    meta: {
      title:'查看渠道'
    }
  },
  {
    path: '/photoVirtualSnLicenseList',
    name: 'photoVirtualSnLicenseList',
    meta: {
      title: '授权许可'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/virtualSnLicenseList'),
  }, {
    path: '/photoVirtualSnBatchList',
    name: 'photoVirtualSnBatchList',
    meta: {
      title: '授权批次'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/virtualSnBatchList'),
  },
  {
    path: '/photoFeedbackList',
    name: 'photoFeedbackList',
    meta: {
      title: '授权反馈'
    },
    component: () => import('@/views/PhotoSystem/deviceManage/feedbackList'),
  },{
    path: '/photoWeek',
    name: 'photoWeek',
    meta: {
      title: '用户报表'
    },
    component: () =>import("@/views/PhotoSystem/bi/week")
  },{
    path: '/photoMonth',
    name: 'photoMonth',
    meta: {
      title: '设备报表'
    },
    component: () =>import("@/views/PhotoSystem/bi/month")
  },{
    path: '/photoYear',
    name: 'photoYear',
    meta: {
      title: '年报'
    },
    component: () =>import("@/views/PhotoSystem/bi/year")
  },{
    path: '/modelContrast',
    name: 'modelContrast',
    meta: {
      title: '机型对比'
    },
    component: () =>import("@/views/PhotoSystem/deviceManage/modelContrast")
  },{
    path: '/photoUserLoginLog',
    name: 'photoUserLoginLog',
    meta: {
      title: 'app用户登录日志'
    },
    component: () =>import("@/views/PhotoSystem/baby/photoUserLoginLog")
  },{
    path: '/deviceLogin',
    name: 'deviceLogin',
    meta: {
      title: '设备登录日志'
    },
    component: () =>import("@/views/PhotoSystem/bi/deviceLogin")
  },{
    path: '/photoOtaTrack',
    name: 'photoOtaTrack',
    meta: {
      title: '设备升级跟踪'
    },
    component: () =>import('@/views/PhotoSystem/bi/otaTrack')
  },{
    path: '/photoOtaBlackList',
    name: 'photoOtaBlackList',
    meta: {
      title: 'ota升级黑名单'
    },
    component: () =>import('@/views/PhotoSystem/ota/photoOtaBlackList')
  },{
    path: '/deviceAuthConfig',
    name: 'deviceAuthConfig',
    meta: {
      title: '项目授权配置项'
    },
    component:() =>import('@/views/PhotoSystem/deviceManage/deviceAuthConfig')
  },{
    path: '/mapStringList',
    name: 'mapStringList',
    meta: {
      title: 'mapString管理'
    },
    component:() =>import('@/views/account/mapStringList')
  },{
    path: '/userModelRank',
    name: 'userModelRank',
    meta: {
      title: '用户手机排名'
    },
    component:() =>import("@/views/PhotoSystem/baby/userModelRank")
  },{
    path: '/emailSendLog',
    name: 'emailSendLog',
    meta: {
      title: '邮箱发送日志'
    },
    component:() =>import("@/views/PhotoSystem/log/emailSendLog")
  },{
    path: '/uploadPhotoLog',
    name: 'uploadPhotoLog',
    meta: {
      title: '图片上传日志'
    },
    component:() =>import("@/views/PhotoSystem/log/uploadPhotoLog")
  },{
    path: '/userBindDeviceLog',
    name: 'userBindDeviceLog',
    meta: {
      title: '用户绑定设备日志'
    },
    component:() =>import("@/views/PhotoSystem/log/userBindDeviceLog")
  },{
    path: '/photoBannerList',
    name: 'photoBannerList',
    meta: {
      title: 'banner管理'
    },
    component:() =>import("@/views/PhotoSystem/banner/bannerList")
  },{
    path: '/addPhotoBanner',
    name: 'addPhotoBanner',
    meta: {
      title: '新增banner'
    },
    component:() =>import("@/views/PhotoSystem/banner/addBanner")
  },{
    path: '/editPhotoBanner',
    name: 'editPhotoBanner',
    meta: {
      title: '编辑banner'
    },
    component:() =>import("@/views/PhotoSystem/banner/editBanner")
  },{
    path: '/viewPhotoBanner',
    name: 'viewPhotoBanner',
    meta: {
      title: '查看banner'
    },
    component:() =>import("@/views/PhotoSystem/banner/viewBanner")
  }, {
    path: '/newCodeLog',
    name: 'newCodeLog',
    meta: {
      title: '(新)设备邀请码'
    },
    component:() =>import("@/views/PhotoSystem/deviceCode/newCodeLog")
  }, {
    path: '/oldCodeLog',
    name: 'oldCodeLog',
    meta: {
      title: '(旧)设备邀请码'
    },
    component:() =>import("@/views/PhotoSystem/deviceCode/oldCodeLog")
  }, {
    path: '/giftView',
    name: 'giftView',
    meta: {
      title: '礼物任务列表'
    },
    component:() =>import("@/views/PhotoSystem/baby/giftView")
  }, {
    path: '/photoApkUpdateList',
    name: 'photoApkUpdateList',
    meta: {
      title: 'apk列表'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/apkUpdateList.vue")
  }, {
    path: '/addPhotoApkUpdateList',
    name: 'addPhotoApkUpdateList',
    meta: {
      title: '新增Apk'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/add.vue")
  }, {
    path: '/editPhotoApkUpdateList',
    name: 'editPhotoApkUpdateList',
    meta: {
      title: '编辑Apk'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/edit.vue")
  }, {
    path: '/addPhotoApkUpdateItem',
    name: 'addPhotoApkUpdateItem',
    meta: {
      title: '新增apk项目'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/addItem.vue")
  }, {
    path: '/viewPhotoApkUpdateItem',
    name: 'viewPhotoApkUpdateItem',
    meta: {
      title: '查看apk项目'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/viewItem.vue")
  }, {
    path: '/editPhotoApkUpdateItem',
    name: 'editPhotoApkUpdateItem',
    meta: {
      title: '编辑apk项目'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/editItem.vue")
  }, {
    path: '/addPhotoApkItem',
    name: 'addPhotoApkItem',
    meta: {
      title: '新增apk项目'
    },
    component:()=> import("@/views/PhotoSystem/apply/apkUpdateList/addItemTwo.vue")
  }, {
    path: '/phoneEventBi',
    name: 'phoneEventBi',
    meta: {
      title: '事件分析'
    },
    component:() => import("@/views/PhotoSystem/bi/eventBi.vue")
  }

]



// WEBPACK FOOTER //
// ./src/router/photoRouter.js